module.exports = __webpack_public_path__ + "static/media/confirm.e9d4e871.mp3";